import Vue from 'vue';
import injector from 'vue-inject';

require('./popup');

let api     = injector.get('api'),
    popup   = injector.get('popup'),
    status = injector.get('status');

class Payout {
    create (params) {
        this.data = params;
    }

    generateToken () {
        return new Promise((resolve) => {
            Vue.http.get(api.token.generate('TWO_STEP_PAYOUT_VERIFICATION')).then(() => {
                resolve ();
            }, error => {
                popup.show(error.data.errors[0]);
            });
        });
    }

    setToken (token) {
        this.data['token'] = token;
    }

    submit() {
        return new Promise((resolve, reject) => {
            Vue.http.post(api.payout.request, this.data).then(() => {
                popup.show('Payout success', 'OK', true);
                resolve();
            }, error => {
                if (status['status' + error.status]) {
                    status['status' + error.status]();
                } else {
                    if (error.data && error.data.message) {
                        popup.show(error.data.message[Object.keys(error.data.message)[0]][0]);
                    }
                    else if (error.data && error.data.errors) {
                        popup.show(error.data.errors[0].message);
                    }
                }
                reject();
            })
        })
    }
}

injector.service('payout', Payout);



// WEBPACK FOOTER //
// ./src/services/payout.js